import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './ServiceHistory.module.scss';
import 'src/css/themes.scss';
import ServiceHistoryPanel from 'src/components/ConnectedVehicle/ServiceHistory/ServiceHistoryPanel/containers/ServiceHistoryPanel';
import { IconSeeMore } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { Dialog, ScrollBar } from '@framework-controls/core';
import { strings } from 'src/localization';
import { random } from 'lodash';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
}

const ServiceHistory = (props: IProps) => {
    const [infoOpen, setInfoOpen] = useState(false);
    const toggleInfo = useCallback(() => {
        setInfoOpen(!infoOpen);
    }, [infoOpen]);

    let firstRoDate: ReactElement | null = null;
    if (props.connectedVehicle.firstRoDate) {
        firstRoDate =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.FirstRepairOrderDate}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.firstRoDate}
                </div>
            </span>;
    }

    let lastRoNum: ReactElement | null = null;
    if (props.connectedVehicle.lastRoNum) {
        lastRoNum =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.LastRepairOrderNumber}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.lastRoNum}
                </div>
            </span>;
    }

    let lastRoDate: ReactElement | null = null;
    if (props.connectedVehicle.lastRoDate) {
        lastRoDate =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.LastRepairOrderDate}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.lastRoDate}
                </div>
            </span>;
    }

    let lastRoMile: ReactElement | null = null;
    if (props.connectedVehicle.lastRoMile) {
        lastRoMile =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.LastRepairOrderOdometer}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.lastRoMile}
                </div>
            </span>;
    }

    let roData: ReactElement | null = null;
    if (firstRoDate || lastRoNum || lastRoDate || lastRoMile) {
        roData =
            <div className={css.infoRow}>
                {firstRoDate}
                {lastRoNum}
                {lastRoDate}
                {lastRoMile}
            </div>;
    }

    let history: ReactElement[] | null = null;
    if (props.connectedVehicle.svcHist.length > 0) {
        history = props.connectedVehicle.svcHist.map((hist, index) => <ServiceHistoryPanel
            key={random(99999)}
            index={index}
        />);
    }

    return (
        <div>
            <span className={css.header}>
                <div className={css.headerLit}>{strings.ViewServiceHistory}</div>
                <IconSeeMore className={css.icon} onClick={() => toggleInfo()} />
            </span>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={infoOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.ServiceHistory.toUpperCase()}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={() => toggleInfo()}
                onBackDropClick={() => toggleInfo()}
                width={'full'}
            >
                <ScrollBar scrollVertical>
                    {roData}
                    <div className={css.history}>
                        {history}
                    </div>
                </ScrollBar>
            </Dialog>
        </div>
    );
};

export default ServiceHistory;